import '../stylesheets/application.scss'

import jQuery from 'jquery'
import { createApp } from 'vue'
import DashboardApp from '../components/DashboardApp.vue'
import { collectionneurAssets } from '../utils/assets'

window.$ = window.jQuery = jQuery
window.CollectionneurAssets = collectionneurAssets

async function startApplication() {
  await import('jquery-ujs')

  var dashboardElement = document.getElementById('dashboard-app')
  if (dashboardElement) {
    createApp(DashboardApp, {
      pinsUrl: dashboardElement.dataset.pinsUrl
    }).mount(dashboardElement)
  }
}

startApplication()
